import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Register from '@/components/Register'
import Users from '@/components/Users'
import ProfileCard from '@/components/Profile/ProfileCard'
import ProfileEdit from '@/components/Profile/ProfileEdit'
import ChangePassword from '@/components/ChangePassword'
import Overview from '@/components/Overview'
import New from '@/components/New'
import Calendar from '@/components/Calendar'
import Search from '@/components/Search'
import CarList from '@/components/Car/CarList'
import CarAdd from '@/components/Car/CarAdd'
import CarCard from '@/components/Car/CarCard'
import CarEdit from '@/components/Car/CarEdit'
import CarUpdate from '@/components/Car/CarUpdate'
import CarHistory from '@/components/Car/CarHistory'
import MotoList from '@/components/Moto/MotoList'
import MotoAdd from '@/components/Moto/MotoAdd'
import MotoCard from '@/components/Moto/MotoCard'
import MotoEdit from '@/components/Moto/MotoEdit'
import MotoUpdate from '@/components/Moto/MotoUpdate'
import MotoHistory from '@/components/Moto/MotoHistory'
import HouseList from '@/components/House/HouseList'
import HouseAdd from '@/components/House/HouseAdd'
import HouseCard from '@/components/House/HouseCard'
import HouseEdit from '@/components/House/HouseEdit'
import HouseUpdate from '@/components/House/HouseUpdate'
import HouseHistory from '@/components/House/HouseHistory'
import HealthList from '@/components/Health/HealthList'
import HealthAdd from '@/components/Health/HealthAdd'
import HealthCard from '@/components/Health/HealthCard'
import HealthEdit from '@/components/Health/HealthEdit'
import HealthUpdate from '@/components/Health/HealthUpdate'
import HealthHistory from '@/components/Health/HealthHistory'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { 
          guest: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { 
        onlyAdmin: true
      }
    },
    {
      path: '/',
      name: 'Overview',
      component: Overview,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/new',
      name: 'New',
      component: New,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car',
      name: 'CarList',
      component: CarList,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car/add',
      name: 'CarAdd',
      component: CarAdd,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car/:id',
      name: 'CarCard',
      component: CarCard,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car/:id/edit',
      name: 'CarEdit',
      component: CarEdit,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car/:id/update',
      name: 'CarUpdate',
      component: CarUpdate,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/car/:id/history',
      name: 'CarHistory',
      component: CarHistory,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto',
      name: 'MotoList',
      component: MotoList,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto/add',
      name: 'MotoAdd',
      component: MotoAdd,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto/:id',
      name: 'MotoCard',
      component: MotoCard,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto/:id/edit',
      name: 'MotoEdit',
      component: MotoEdit,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto/:id/update',
      name: 'MotoUpdate',
      component: MotoUpdate,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/moto/:id/history',
      name: 'MotoHistory',
      component: MotoHistory,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house',
      name: 'HouseList',
      component: HouseList,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house/add',
      name: 'HouseAdd',
      component: HouseAdd,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house/:id',
      name: 'HouseCard',
      component: HouseCard,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house/:id/edit',
      name: 'HouseEdit',
      component: HouseEdit,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house/:id/update',
      name: 'HouseUpdate',
      component: HouseUpdate,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/house/:id/history',
      name: 'HouseHistory',
      component: HouseHistory,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health',
      name: 'HealthList',
      component: HealthList,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health/add',
      name: 'HealthAdd',
      component: HealthAdd,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health/:id',
      name: 'HealthCard',
      component: HealthCard,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health/:id/edit',
      name: 'HealthEdit',
      component: HealthEdit,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health/:id/update',
      name: 'HealthUpdate',
      component: HealthUpdate,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/health/:id/history',
      name: 'HealthHistory',
      component: HealthHistory,
      props: true,
      meta: { 
          requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      props: true,
      meta: { 
        onlyAdmin: true,
      }
    },
    {
      path: '/profile',
      name: 'ProfileCard',
      component: ProfileCard,
      props: true,
      meta: { 
        requiresAuth: true,
      }
    },
    {
      path: '/profile/edit',
      name: 'ProfileEdit',
      component: ProfileEdit,
      props: true,
      meta: { 
        requiresAuth: true,
      }
    },
    {
      path: '/change-password',
      name: 'Change password',
      component: ChangePassword,
      props: true,
      meta: { 
        requiresAuth: true,
      }
    },
    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  localStorage.setItem('SAV_CRM_PREV_ROUTE', from.name);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (Vue.cookie.get('sav-erp-token') == null && Vue.cookie.get('sav-erp-refresh-token') == null ) {
      Vue.cookie.delete('sav-erp-token');
      Vue.cookie.delete('sav-erp-refresh-token');
      localStorage.removeItem('user');
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else if(to.matched.some(record => record.meta.guest)) {
    if (Vue.cookie.get('sav-erp-token') == null && Vue.cookie.get('sav-erp-refresh-token') == null ) {
      Vue.cookie.delete('sav-erp-token');
      Vue.cookie.delete('sav-erp-refresh-token');
      localStorage.removeItem('user');
      next()
    } else {
      next({ name: 'Overview'})
    }
  } else if(to.matched.some(record => record.meta.onlyAdmin)) {
    if (JSON.parse(localStorage.getItem('sav-erp-user')) !== null) {
      if (JSON.parse(localStorage.getItem('sav-erp-user')).admin ) {
        next()
      } else {
        next({ name: 'Overview'})
      }
    } else {
      next({ name: 'Login'})
    }
  }
})
